<section class="login">
  <h1>Please login to access the goodness...</h1>

  <h5>To have access, you must be a member of one of these groups</h5>
  <div class="user-label"><span class="role">Admins</span>Connex-DevOps</div>
  <div class="user-label"><span class="role">Writers</span>VSTS-NA-SalesExperience-Contributors</div>
  <div class="user-label"><span class="role">Observers</span>VSTS-NA-SalesExperience-ReleaseManagers, VSTS-NA-SalesExperience-Readers</div>
</section>